<template>
  <div class="form-h5 h5-wrap">
    <h3>基本信息</h3>
    <el-form :model="ruleForm" :rules="rules" label-position="top" ref="ruleForm">
      <el-form-item label="个人姓名" prop="name">
        <el-input v-model="ruleForm.name" placeholder="请输入您的姓名"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="id_number">
        <el-input v-model="ruleForm.id_number" placeholder="请输入您的身份证号"></el-input>
      </el-form-item>
      <el-form-item label="手机号码">
        <el-input v-model="phone" placeholder="请输入您的手机号码" disabled></el-input>
      </el-form-item>
      <el-form-item class="redStarPic" label="个人照片" prop="faces" v-loading="loadingImg" v-if="!(org_type === 'apartment'&&!face_toggle)">
        <el-checkbox style="display:none" v-model="ruleForm.faces"></el-checkbox>
        <el-upload
          v-for="index in 3" :key="index"
          :with-credentials="true"
          action=""
          :http-request="uploadImg.bind(null, index)"
          accept="image/*"
          class="avatar-uploader"
          :class="'avatar-uploader'+index"
          :show-file-list="false">
          <template v-if="imgUrl[index]">
            <img :src="imgUrl[index]" class="avatar">
          </template>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <h3>补充信息</h3>
      <template v-if="org_type === 'apartment'">
      <el-form-item class="redStar" label="详细居住地址" prop="adressDetail">
        <el-input style="margin-bottom: 10px" v-model="ruleForm.building" placeholder="请输入楼牌号(若无楼牌号请填无)">
          <template slot="append">号楼</template>
        </el-input>
        <el-input style="margin-bottom: 10px" v-model="ruleForm.unit" placeholder="请输入单元号(若无单元号请填无)">
          <template slot="append">单元</template>
        </el-input>
        <el-input v-model="ruleForm.room" placeholder="请输入门牌号(若无门牌号请填无)">
          <template slot="append">室</template>
        </el-input>
      </el-form-item>
      <template v-if="hasMembers">
        <div v-for="(members,index) in ruleForm.members" :key="index">
          <el-form-item label="家属姓名" :prop="'members.'+index+'.name'" :rules="{
            required: true, message: '家属姓名不能为空', trigger: 'blur'
          }">
            <el-input v-model="members.name" placeholder="请输入您家属的姓名"></el-input>
          </el-form-item>
          <el-form-item label="与本人的亲属关系" :prop="'members.'+index+'.relation'" :rules="{
            required: true, message: '亲属关系不能为空', trigger: 'blur'
          }">
            <el-input v-model="members.relation" placeholder="请输入家属与本人的亲属关系"></el-input>
          </el-form-item>
          <el-form-item label="家属身份证号" :prop="'members.'+index+'.id_number'" :rules="checkID()">
            <el-input v-model="members.id_number" placeholder="请输入您家属的身份证号"></el-input>
          </el-form-item>
        </div>
      </template>
      <div style="text-align:right;margin: -.2rem 0 .2rem">
        <el-button type="primary" icon="el-icon-plus" size="mini" @click="addMembers">添加家庭成员</el-button>
      </div>
      </template>
      <el-form-item label="您及家人是否前往过湖北、浙江、广东等疫情区(2020年1月10日起)" prop="whether_transit">
        <el-radio-group v-model="ruleForm.whether_transit">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="您及家人是否与湖北、浙江、广东等疫情区人员有接触史" prop="whether_touch">
        <el-radio-group v-model="ruleForm.whether_touch">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="您及家人近期是否乘坐过火车、飞机(2020年1月10日起)" prop="whether_traffic">
        <el-radio-group v-model="ruleForm.whether_traffic">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="其他需要填报事项">
        <el-input type="textarea" v-model="ruleForm.supplement" placeholder="请输入其他需要填报事项"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="button" type="primary" :loading="loading" @click="submitForm('ruleForm')">提交信息</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {checkID} from '../../utils'
export default {
  name: 'PersonForm',
  data() {
    return {
      loadingImg: false,
      loading: false,
      phone: '',
      org_type: '', 
      face_toggle: true,
      hasMembers: false,
      imgUrl: {},
      ruleForm: {
        organization_id: +this.$store.getters.getCompanyInfo.organization_id,
        name: '',
        id_number: '',
        faces: [],
        building: '',
        unit: '',
        room: '',
        members: [],
        whether_transit: '',
        whether_touch: '',
        whether_traffic: '',
        supplement: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ],
        adressDetail: [
          { validator: (rule, value, callback) =>{
            if (this.ruleForm.building === '') {
              callback(new Error('*请输入楼牌号(若无楼牌号请填无)'))
              return false ;
            } 
            if (this.ruleForm.unit === '') {
              callback(new Error('*请输入单元号(若无单元号请填无)'))
              return false ;
            } 
            if (this.ruleForm.room === '') {
              callback(new Error('*请输入门牌号(若无门牌号请填无)'))
              return false ;
            } 

            callback();
          }, trigger: 'change' },
        ],
        whether_transit: [
          { required: true, message: '请选择是否前往过湖北、浙江、广东等疫情区', trigger: 'change' }
        ],
        whether_touch: [
          { required: true, message: '请选择是否与湖北、浙江、广东等疫情区人员有接触史', trigger: 'change' }
        ],
        whether_traffic: [
          { required: true, message: '请选择是否乘坐过火车、飞机', trigger: 'change' }
        ],
        id_number: this.checkID(),
        faces: [
          {type: 'array', required: true, message: '请上传三张清晰个人头像', trigger: 'change'},
          { validator: (rule, value, callback) =>{
            if (value&&value.length === 3) {
              callback();
            } else {
              callback(new Error('*请上传三张清晰个人头像'))
            }

          }, trigger: 'change'}
        ]
      }
    }
  },
  mounted() {
    let query = this.$route.query;
    this.phone = query.phone;
    this.org_type = query.org_type;
    this.face_toggle = +query.face_toggle;
  },
  methods: {
    addMembers() {
      this.hasMembers = true;
      this.ruleForm.members.push({
        name: '',
        id_number:'',
        relation: ''
      })
    },
    convertBase64UrlToBlob(urlData) {
        var arr = urlData.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    },
    photoCompress(fileObj){
      var ready = new FileReader(),
          size = fileObj.size / 1024,
          rate = 1,
          quality = 1; // quality值越小，所绘制出的图像越模糊
      // 512是512KB，大于512对图片进行压缩，可根据实际情况修改大小(压缩并不精确，大概是这个范围)
      if(size > 1024) {
        quality = 1024 / size;
        rate = Math.round(size/1024)
      } 

      /*开始读取指定的Blob对象或File对象中的内容. 当读取操作完成时,readyState属性的值会成为DONE,
      如果设置了onloadend事件处理程序,则调用之.同时,result属性中将包含一个data: URL格式的字符串以表示所读取文件的内容.*/
      return new Promise((resolve, reject)=>{
        ready.readAsDataURL(fileObj);
        ready.onload = function() {
          var img = new Image();
          img.src = this.result;
          img.onload = function() {
              var that = this,
                  w = that.width/rate,
                  h = that.height/rate,
                  r = h/w;
              //生成canvas
              if(h > 4096) {
                h = 4096;
                w = 4096/r;
              }
              if(w > 4096) {
                w = 4096
                h = 4096*r
              }
              var canvas = document.createElement('canvas'),
                  ctx = canvas.getContext('2d');
              
              canvas.setAttribute('width', w);
              canvas.setAttribute('height', h);
              ctx.drawImage(that, 0, 0, w, h);

              var base64 = canvas.toDataURL(fileObj.type, quality)
              // var strLength = base64.length;
              // var fileLength=parseInt(strLength-(strLength/8)*2);
              // console.log(fileLength)
              resolve(base64)
          }
        }
      })
      
    },

    uploadImg(index, f) {
      this.getSymptoms().then(r=>{
        let file = f.file;
        let formData = new FormData();
        this.photoCompress(file).then(dataImage => {
          formData.append('file',this.convertBase64UrlToBlob(dataImage))
          formData.append('name',file.name)
            this.loadingImg = true;
            this.axios.post(`person/face/detect`,formData, {headers: {
              'Content-Type': 'multipart/form-data' //请求头
            }}).then(r=>{
              this.loadingImg = false;
              if(r.data.code === 200){
                this.ruleForm.faces[index-1] = r.data.data;
                this.imgUrl[index] = dataImage;
              } else {
                this.$message({
                  type: 'error',
                  message: r.data.msg,
                  customClass: 'message-style'
                });
              }
            }).catch(err=>{
              this.loadingImg = false;
              this.$message({
                message: err || '服务异常',
                customClass: 'message-style',
                type: 'error'
              })
            })
        });
      })
    },
    getSymptoms() {
      return new Promise((resolve, reject)=>{
        this.axios.get('/person/symptoms').then(r => {
          if(r.data.code === 200) {
            resolve()
          }
        }).catch( err => {
          reject(err)
          console.log(err)
        })
      })
    },
    checkID() {
      return [
        { required: true, message: '请输入您的身份证号', trigger: 'blur' },
        { validator: (rule, value, callback) => {
          if (!checkID(value)) {
            callback(new Error('*身份证号格式错误'))
            return false ;
          } else {
            callback();
          }
        }, trigger: 'blur'}
      ]
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          let condition = JSON.parse(JSON.stringify(this.ruleForm));
          this.axios.put('person/', condition).then(r => {
            this.loading = false;
            if(r.data.code === 200){
              localStorage.setItem('personInfo', JSON.stringify(condition))
              this.$router.replace('/h5/success')
            } else {
              this.$message({
                type: 'error',
                message: r.data.msg,
                customClass: 'message-style'
              });
            }
          }).catch( err => {
            console.log(err)
            this.loading = false
            this.$message({
              message: err || '服务异常',
              type: 'error',
              customClass: 'message-style'
            })
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.form-h5 {
  padding: .15rem;
  h3 {
    position: relative;
    padding-left: .08rem;
    margin: 0 0 .23rem;
    font-family: 'PingFangSC-Semibold';
    line-height: 1;
    font-size: .18rem;
    color: #333333;
    border-left: 3px solid #7C5FCA;
    &:after{
      content: '';
      position: absolute;
      left: 0;
      bottom: -.12rem;
      width: 100%;
      border-bottom: 1px solid rgba(151, 151, 151, .2);
    }
  }
  .el-form-item {
    margin-bottom: .2rem;
  }
  .button {
    width: 100%;
    height: .5rem;
    margin: .15rem 0 0
  }
}

.avatar-uploader {
  float: left;
  margin-top: .1rem;
}
.avatar-uploader2{
  margin: .1rem .19rem 0;
}
.avatar {
  width: .9rem;
  height: .9rem;
  display: block;
}
</style>

<style lang="scss">
.form-h5  {
  .el-input input {
    padding-left: 0;
    height: .3rem;
    line-height: .3rem;
    font-size: .13rem;
    border-radius: 0;
    border-width: 0 0 1px 0;
  }
  .el-textarea {
    margin-top: .1rem;
  }
  .el-form--label-top .el-form-item__label {
    padding-bottom: 0;
    line-height: .2rem;
    font-size: .16rem;
  }
  .el-input-group__append {
    background: transparent;
    border-width: 0 0 1px 0;
  }
  .redStar .el-form-item__label:before {
    content: '*' !important;
    color: #F56C6C;
    margin-right: 4px
  }
  .redStarPic .el-form-item__label:after {
    content: '(请上传3张清晰个人头像照片)' !important;
    margin-left: .1rem;
    font-size: .12rem;
    color: #F56C6C;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #7C5FCA;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader-icon {
    font-size: .28rem;
    color: #7C5FCA;
    width: .9rem;
    height: .9rem;
    line-height: .9rem;
    text-align: center;
  }
}
</style>